@if (errorMessage() && condition()) {
  <div
    [class.error-container]="type() === 'error'"
    [class.success-container]="type() === 'success'"
  >
    @if (type() === 'success') {
      <lucide-icon [img]="CheckCircle2"></lucide-icon>
    } @else {
      <lucide-icon [img]="XCircle"></lucide-icon>
    }

    <span [class.error]="type() === 'error'" [class.success]="type() === 'success'">
      {{ errorMessage() }}
    </span>
  </div>
}
